import { render } from "./EcoleDescription.vue?vue&type=template&id=750b9c96"
import script from "./EcoleDescription.vue?vue&type=script&lang=js"
export * from "./EcoleDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__